import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "32",
  height: "32",
  viewBox: "0 0 32 32",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M16.0007 20V22.6667M8.00065 28H24.0006C25.4734 28 26.6673 26.8061 26.6673 25.3333V17.3333C26.6673 15.8606 25.4734 14.6667 24.0006 14.6667H8.00065C6.52789 14.6667 5.33398 15.8606 5.33398 17.3333V25.3333C5.33398 26.8061 6.52789 28 8.00065 28ZM21.334 14.6667V9.33333C21.334 6.38781 18.9462 4 16.0007 4C13.0551 4 10.6673 6.38781 10.6673 9.33333V14.6667H21.334Z",
      stroke: "#EA8000",
      "stroke-width": "2",
      "stroke-linecap": "round"
    }, null, -1)
  ])))
}
export default { render: render }